// extracted by mini-css-extract-plugin
module.exports = {"item":"ExistingSessionSection_item__3oUgr","sessionListContainer":"ExistingSessionSection_sessionListContainer__1BLsj"};